import { createSlice } from "@reduxjs/toolkit";
import { updateTeacherProfile, fetchTeacherProfile } from "./operation.js";

const initialState = {
  profile: null,
  loading: false,
  error: null,
};

const teacherSlice = createSlice({
  name: "teacher",
  initialState,
  reducers: {
    resetTeacherProfile() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeacherProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(fetchTeacherProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTeacherProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTeacherProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = {
          ...state.profile,
          ...action.meta.arg,
          avatar: action.payload.avatar || state.profile.avatar,
          introVideo:
            action.payload.introVideo ||
            action.meta.arg.introVideo ||
            state.profile.introVideo,
          concertVideo:
            action.payload.concertVideo ||
            action.meta.arg.concertVideo ||
            state.profile.concertVideo,
        };
      })
      .addCase(updateTeacherProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetTeacherProfile } = teacherSlice.actions;
export default teacherSlice.reducer;
